"use strict";
/* globals module */
/**
 * @module commerceLookupsAddressTypeBatchClient
 * @description  Commerce Lookups Address Type Batch Client provides an easy way to consume  Commerce REST API end-points. In order to obtain a needed routes `commerceLookupsAddressTypesBatchClient` uses `commerceLookupsAddressTypeBatchRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
;
var httpApi_1 = require("../../../../httpApi");
var __1 = require("../../");
var CommerceLookupsAddressTypesBatchClient = /** @class */ (function () {
    function CommerceLookupsAddressTypesBatchClient(commerceLookupsAddressTypeBatchRoute, apiClient) {
        this.commerceLookupsAddressTypeBatchRoute = commerceLookupsAddressTypeBatchRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(CommerceLookupsAddressTypesBatchClient.prototype, "routeDefinition", {
        get: function () {
            return this.commerceLookupsAddressTypeBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the create commerce action has been performed; this action creates a new commerce resources.
     * @method
     * @example commerceLookupsAddressTypeBatchClient.create([{
                     name : '<name>',
                     abrv: '<abbreviation>',
                     description: '<description>'
                    }])
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    CommerceLookupsAddressTypesBatchClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update commerce action has been performed; this action updates specified commerce resources.
     * @method
     * @example   commerceLookupsAddressTypeBatchClient.update(commerceAddressTypes)
                       .then(function (data) {
                           // perform success action here
                       },
                        function (response, status, headers, config) {
                            // perform error handling here
                       });
    **/
    CommerceLookupsAddressTypesBatchClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove commerce action has been performed. This action will remove commerce resources from the system if successfully completed.
     * @method
     * @example commerceLookupsAddressTypeClient.remove(commerceAddressTypeIds)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    CommerceLookupsAddressTypesBatchClient.prototype.remove = function (ids) {
        return this.apiClient.delete(this.commerceLookupsAddressTypeBatchRoute.delete(), undefined, ids);
    };
    var _a, _b;
    CommerceLookupsAddressTypesBatchClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.CommerceLookupsAddressTypeBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.CommerceLookupsAddressTypeBatchRoute !== "undefined" && __1.CommerceLookupsAddressTypeBatchRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], CommerceLookupsAddressTypesBatchClient);
    return CommerceLookupsAddressTypesBatchClient;
}());
exports.CommerceLookupsAddressTypesBatchClient = CommerceLookupsAddressTypesBatchClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 
